import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export class PharmacyInfo {
  id: number;
  pharmacySourceId: number;
  externalId?: any;
  externalSource?: any;
  internalDescription?: any;
  displayDescription?: any;
  name: string;
  phone: string;
  fax?: any;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  zipExt?: any;
  country?: any;
  latitude: string;
  longitude: string;
  active?: any;
  dateCreated: Date;
  createdBy: number;
  dateUpdated?: any;
  updatedBy?: any;
  deleted: boolean;
  dateDeleted?: any;
  deletedBy?: any;
  operationDetail: OperationDetail;
  priceLevel: string;
  webSite?: any;
  scope?: any;
  detailSource?: any;
  detailSourceId: string;
  detailRefId?: any;
  mapLink?: any;
  addressHtml?: any;
  mapIcon: string;
  pharmacyReviews?: any;
  pharmacySpecialtyType?: any;
  rating?: any
  mapUrl: SafeResourceUrl;
}

export class OperationDetail {
  id: number;
  pharmacyId: number;
  isOpen: boolean;
  daysOfWeek?: any;
  timeOpen?: any;
  timeClosed?: any;
  is24Hour: boolean;
  displayHours: any[];
  active?: any;
  dateCreated: Date;
  createdBy: number;
  dateUpdated?: any;
  updatedBy?: any;
  deleted: boolean;
  dateDeleted?: any;
  deletedBy?: any;
}

export class PatientPreferedPharmacy {
  id: number;
  externalId?: any;
  name: string;
  phone?: any;
  fax?: any;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  active: boolean;
}